import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const STATS = [
  { k: "+30", l: "Anos de Experiência" },
  { k: "8", l: "Categorias de Produtos" },
  { k: "12", l: "Marcas Parceiras" },
  { k: "100%", l: "Cobertura Nacional" },
];

export default function HomeHero() {
  return (
    <section className="relative overflow-hidden">
      <div className="hero-bg relative grain">
        <div className="absolute inset-0 stripes opacity-40" />
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-28 md:py-44 grid grid-cols-12 gap-6 items-center">
          <div className="hidden md:block col-span-1">
            <div className="vlabel text-[#1FA8E0]">CETIBER · MAIA · PT</div>
          </div>
          <div className="col-span-12 md:col-span-9 text-white">
            <div className="overline mb-6" data-testid="hero-overline">
              Especialistas em Sistemas de Fixação
            </div>
            <h1
              data-testid="hero-title"
              className="font-display font-black uppercase leading-[0.92] tracking-tight text-5xl sm:text-6xl lg:text-7xl xl:text-[92px]"
            >
              Soluções de<br />
              Fixação e <span className="text-[#1FA8E0]">Acessórios</span><br />
              Industriais
            </h1>
            <p className="mt-8 max-w-2xl text-lg md:text-xl text-white/80 leading-relaxed">
              Qualidade, durabilidade e desempenho para profissionais exigentes.
              Parceiros das principais marcas do setor industrial.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link to="/produtos" data-testid="hero-cta-products" className="btn-cet btn-primary">
                Ver Produtos <ArrowUpRight size={18} />
              </Link>
              <Link to="/contactos" data-testid="hero-cta-contact" className="btn-cet btn-outline-light">
                Contactar
              </Link>
            </div>
          </div>
        </div>

        <div className="relative border-t border-white/10 bg-black/30 backdrop-blur-sm">
          <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-5 grid grid-cols-2 md:grid-cols-4 gap-6 text-white">
            {STATS.map((s) => (
              <div key={s.l} className="flex items-baseline gap-3">
                <span className="font-display font-black text-4xl text-[#1FA8E0]">{s.k}</span>
                <span className="font-mono-cet text-[11px] uppercase tracking-[0.2em] text-white/70">{s.l}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
